module.exports = __webpack_public_path__ + "static/mobile-ritual-e4664e1a5503af106e0628db4e77a5e2.png";